import apiClient from "./apiClient";

const API_URL = `/kardex/elimination-output`;

export const createElimination = async (eliminationData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(`${API_URL}/create-elimination`, eliminationData);
  return response.data;
};

export const getEliminationByAdmissionId = async (admissionId) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`${API_URL}/admission/${admissionId}`);
    return response.data;
  } catch (error) {
    if (
      error.response?.status === 500 &&
      (error.response?.data?.message?.includes("Failed to retrieve") ||
        error.response?.data?.message?.includes("from table") ||
        error.response?.data?.message?.includes("does not exist"))
    ) {
      return [];
    }
    throw error;
  }
};

export default {
  createElimination,
  getEliminationByAdmissionId,
};